"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const merchant_portal_components_1 = require("merchant-portal-components");
const useStatusModal = () => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const [status, setStatus] = (0, react_1.useState)(null);
    const openModal = () => {
        setIsOpen(true);
    };
    const closeModal = () => {
        setIsOpen(false);
        setStatus(null);
    };
    const handleClick = (data) => {
        setStatus({
            accountNumber: data.alphaeonAccountNumber,
            transactionId: data.id,
            transactionStatus: data.status,
            expirationDate: data.authRequestExpiresAt ?? '',
        });
        setIsOpen(true);
    };
    const StatusModal = () => {
        const modalData = status ?? {
            accountNumber: '',
            transactionId: '',
            transactionStatus: '',
            expirationDate: '',
        };
        return ((0, jsx_runtime_1.jsx)(merchant_portal_components_1.TransactionStatusModalShell, { isOpen: isOpen, setIsOpen: setIsOpen, accountNumber: modalData.accountNumber, transactionId: Number(modalData.transactionId), transactionStatus: modalData.transactionStatus, expirationDate: modalData.expirationDate }));
    };
    return {
        StatusModal,
        isOpen,
        status,
        openModal,
        closeModal,
        handleClick,
    };
};
exports.default = useStatusModal;
